import {AbstractCommand} from "./abstract.command";
import {WeeklyWorkingTime} from "../domain/entities/weekly-working-time.entity";
import {CommandName} from "./command-name.enum";

export class CreateWeeklyWorkingTimeCommand extends AbstractCommand<WeeklyWorkingTime> {

    public name: CommandName = CommandName.CREATE_WEEKLY_WORKING_TIME;

    public tags = ['entity', 'create', 'weekly-working-time'];

    constructor(payload: WeeklyWorkingTime) {
        super('employee', payload.employee.uid, payload);
    }
}